var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle389(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 5508,
    viewBox: "0 0 160 5508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    d: "M74,0H86a74,74,0,0,1,74,74V5508a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V74A74,74,0,0,1,74,0Z",
    fill: "#d16c3f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle389);
export default __webpack_public_path__ + "static/media/Rectangle 389.b1ec4e0f88c9a3a76fe8d0871ed06436.svg";
export { ForwardRef as ReactComponent };